/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'export': {
    width: 18,
    height: 22,
    viewBox: '0 0 18 22',
    data: '<path pid="0" _fill="#008cff" d="M9.134 15.003c-.445 0-.806-.376-.806-.84V2.773L5.224 5.792a.785.785 0 01-1.139-.04.865.865 0 01.04-1.188L8.579.231a.787.787 0 01.555-.23.804.804 0 01.304.06.801.801 0 01.246.165l4.46 4.338a.865.865 0 01.04 1.187.783.783 0 01-1.14.041L9.94 2.772v11.39c0 .465-.36.84-.806.84zM17.194 22H.806C.36 22 0 21.624 0 21.16V8.005c0-.464.36-.84.806-.84h4.298c.446 0 .806.376.806.84 0 .464-.36.84-.806.84H1.612V20.32h14.776V8.845h-3.493c-.445 0-.806-.376-.806-.84 0-.464.361-.84.806-.84h4.299c.445 0 .806.376.806.84V21.16c0 .464-.36.84-.806.84z"/>'
  }
})
